import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  /**
   * The deployment group naming production inside the `env` field of the `/Configuration` endpoint, which is
   * built as `<aspnetcore environment>_<deployment group>`. Matched as a substring, so a second production
   * environment — an `ovh_production` next to `aws_production` — is covered without touching this code.
   * Every other value counts as non-production, the demo group and an unknown one included.
   */
  private static readonly PRODUCTION_ENV = 'production';

  private _env = '';
  private _feature1EnabledFlag: boolean;
  private _feature2EnabledFlag: boolean;
  private _feature3EnabledFlag: boolean;
  private _feature4EnabledFlag: boolean;
  private _feature5EnabledFlag: boolean;
  private _identityServerAddress: string;
  private _prothesisApiAddress: string;
  private _prothesisCustomerApiAddress: string;
  private _prothesisIdentityApiAddress: string;
  private _stripePublishableKey: string;

  public get Env(): string {
    return this._env;
  }

  public set Env(env: string) {
    this._env = env;
  }

  public get Feature1EnabledFlag(): boolean {
    return this._feature1EnabledFlag;
  }

  public set Feature1EnabledFlag(feature1EnabledFlag: boolean) {
    this._feature1EnabledFlag = feature1EnabledFlag;
  }

  public get Feature2EnabledFlag(): boolean {
    return this._feature2EnabledFlag;
  }

  public set Feature2EnabledFlag(feature2EnabledFlag: boolean) {
    this._feature2EnabledFlag = feature2EnabledFlag;
  }

  public get Feature3EnabledFlag(): boolean {
    return this._feature3EnabledFlag;
  }

  public set Feature3EnabledFlag(feature3EnabledFlag: boolean) {
    this._feature3EnabledFlag = feature3EnabledFlag;
  }

  public get Feature4EnabledFlag(): boolean {
    return this._feature4EnabledFlag;
  }

  public set Feature4EnabledFlag(feature4EnabledFlag: boolean) {
    this._feature4EnabledFlag = feature4EnabledFlag;
  }

  public get Feature5EnabledFlag(): boolean {
    return this._feature5EnabledFlag;
  }

  public set Feature5EnabledFlag(feature5EnabledFlag: boolean) {
    this._feature5EnabledFlag = feature5EnabledFlag;
  }

  public get IdentityServerAddress(): string {
    return this._identityServerAddress;
  }

  public set IdentityServerAddress(identityServerAddress: string) {
    this._identityServerAddress = identityServerAddress;
  }

  /**
   * Whether the application runs outside production. Gates the switches that relax the legal-identifier
   * validation, and is false on any environment whose name carries the production group.
   */
  public get NonProductionFlag(): boolean {
    return !this._env.includes(ConfigurationService.PRODUCTION_ENV);
  }

  public get ProthesisApiAddress(): string {
    return this._prothesisApiAddress;
  }

  public set ProthesisApiAddress(prothesisApiAddress: string) {
    this._prothesisApiAddress = prothesisApiAddress;
  }

  public get ProthesisCustomerApiAddress(): string {
    return this._prothesisCustomerApiAddress;
  }

  public set ProthesisCustomerApiAddress(prothesisCustomerApiAddress: string) {
    this._prothesisCustomerApiAddress = prothesisCustomerApiAddress;
  }

  public get ProthesisIdentityApiAddress(): string {
    return this._prothesisIdentityApiAddress;
  }

  public set ProthesisIdentityApiAddress(prothesisIdentityApiAddress: string) {
    this._prothesisIdentityApiAddress = prothesisIdentityApiAddress;
  }

  public get StripePublishableKey(): string {
    return this._stripePublishableKey;
  }

  public set StripePublishableKey(stripePublishableKey: string) {
    this._stripePublishableKey = stripePublishableKey;
  }
}
